module.exports = __webpack_public_path__ + "static/media/claims.cf79a592.webp";